<template>
  <div>
    <tree ref="tree" :data="rootStructure" :options="options" @tree:mounted="expandAll">
      <div slot-scope="{ node }" class="tree-text tree-item">
        <span class="tree-item__first-element">{{ node.text }}</span>

        <div class="float-right">
          <action-button
            v-if="showAddButton(node)"
            :label="'Dodaj ' + elementName"
            :event="ADD_ACTION"
            :data="node"
            :permissions="permissionName + '.ADD'"
            @pressed="$emit('add-node', $event)"
          />

          <action-button
            :label="'Edytuj ' + elementName"
            :entity-type="entityType"
            :entity-id="node.id"
            :event="EDIT_ACTION"
            :data="node"
            :permissions="permissionName + '.UPDATE'"
            @pressed="$emit('update', $event)"
          />

          <slot name="actions" :node="node" />

          <action-button
            v-if="!node.isBatch && !node.children.length"
            :label="'Usuń ' + elementName"
            :entity-type="entityType"
            :entity-id="node.id"
            :event="DELETE_ACTION"
            :data="node"
            :permissions="permissionName + '.DELETE'"
            @pressed="$emit('delete', $event)"
          />
        </div>
      </div>
    </tree>
  </div>
</template>

<script>
import Tree from 'liquor-tree';

import ActionButton from '@/components/helpers/ActionButton';
import { ADD_ACTION, DELETE_ACTION, EDIT_ACTION } from '@/utils/constants';

// @vuese
// Drzewo z danymi asynchronicznymi
// @group Tree
export default {
  components: { Tree, ActionButton },
  props: {
    // Typ encji
    entityType: {
      type: String,
      required: true
    },
    // Nazwa uprawnienia
    permissionName: {
      type: String,
      required: true
    },
    // Korzenie drzewa
    rootStructure: {
      type: Array,
      required: true
    },
    // Opcje
    options: {
      type: Object,
      required: true
    },
    // Czy otworzyć węzły na start
    expandAtStart: {
      type: Boolean,
      default: false,
      required: false
    },
    // Nazwa elementu do atrybutu aria-label
    elementName: {
      type: String,
      default: 'jednostkę oświatową'
    }
  },
  data: () => ({
    EDIT_ACTION,
    DELETE_ACTION,
    ADD_ACTION
  }),
  mounted() {
    // Emitowanie drzewa
    this.$emit('tree', this.$refs.tree);
  },
  methods: {
    // @vuese
    // Otwiera wszystkie obecne węzły
    expandAll() {
      if (this.expandAtStart) {
        this.$emit('expandAll');
      }
    },

    // @vuese
    // Czy pokazywać przycisk dodawania węzła
    showAddButton(node) {
      return !node.parent;
    }
  }
};
</script>

<style>
.tree-content .tree-arrow {
  top: -10px;
}

.tree-text.tree-item {
  width: 100%;
}

.tree-item__first-element {
  max-width: 80%;
  display: inline-block;
  overflow: hidden;
  white-space: normal;
}

.tree-anchor {
  max-width: 100%;
  display: block;
}
</style>
